import { useContext } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";

const WorkspaceLayout = () => {
  const { workspaceId } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  // Optional: validate workspaceId
  if (!workspaceId) {
    navigate(`${user?.workspaceIds?.[0]}`);
    // return <Navigate to="/select-workspace" replace />;
  }

  return (
    <>
      {/* Workspace-aware navbar/sidebar can go here */}
      <Outlet />
    </>
  );
};

export default WorkspaceLayout;
